import React from 'react';
import ErrorPage from './ErrorPage';

function ErrorPage403 () {
  return <ErrorPage message="You do not have access to this page" />;
}

export default ErrorPage403;
